import _ from 'lodash'
import {UUID} from '@/plugins/common'
import Format from './format'
export default class Column {
  constructor (args = {}) {
    const defaults = {
      id: UUID.create(),
      name: args.name,
      expressionText: args.expressionText,
      columnId: args.columnId,
      columnType: args.columnType,
      sort: args.sort,
      summary: args.summary,
      // 默认是可导出
      exportable: true,
      hidden: false,
      hiddenExpressionText: '',
      lineWrap: false,
      pinyinName: args.pinyinName,
      pinyinFirstChar: args.pinyinFirstChar,
      basis: args.basis,
      timeFormat: args.timeFormat,
      useThousandth: false,
      progressDisplay: false
    }
    this.format = new Format(args.format)
    _.defaults(this, args, defaults)
  }

  static create (args, sort) {
    args.columnType = args.columnType || 'varchar'
    let expressionText = `$\{${args.id}+${args.relationId},${args.name},${args.columnType && args.columnType.toLocaleLowerCase()}}`

    let param = {
      'name': args.name,
      'columnId': args.id,
      'columnType': args.columnType && args.columnType.toLocaleLowerCase(),
      'sort': sort,
      'expressionText': args.id === undefined ? '' : expressionText,
      pinyinName: args.pinyinName,
      pinyinFirstChar: args.pinyinFirstChar,
      tableName: args.tableName
    }
    if (args.dataType && args.dataType === 'FILE') {
      param.showPicture = {show: false, width: 200, height: 200}
    }
    return new Column(param)
  }
}



// WEBPACK FOOTER //
// ./src/store/report/column.js